/* 
custom.js
Fran: Archivo completo Modificado Por CHATGPT 14/8/26 */

/*
* Palo Alto Theme

*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initReadMoreButtons(scope = document) {
    const paragraphs = scope.querySelectorAll('.rich-text__read_more');
    const buttons = scope.querySelectorAll('.button_read_more');

    if (!paragraphs.length || !buttons.length) return;

    paragraphs.forEach((paragraph, index) => {
      const button = buttons[index];
      if (!button || button.dataset.upngReadMoreReady === 'true') return;

      button.dataset.upngReadMoreReady = 'true';

      const textSpan = button.querySelector('.text_read_more');
      const icon = button.querySelector('.icon_read_more');
      const maxHeight = parseFloat(getComputedStyle(paragraph).maxHeight);

      if (paragraph.scrollHeight > maxHeight) {
        button.classList.add('show');
        paragraph.classList.add('collapsed');
      }

      button.addEventListener('click', function () {
        paragraph.classList.toggle('expanded');
        icon.classList.toggle('rotated');

        textSpan.textContent = paragraph.classList.contains('expanded') 
          ? 'Leer menos' 
          : 'Sigue leyendo';
      });
    });
  }

  function updateCollectionDescriptions(scope = document) {
    scope.querySelectorAll('.description-text').forEach((element) => {
      element.classList.remove('truncated');
      element.classList.toggle('truncated', element.scrollHeight > element.clientHeight + 1);
    });
  }

  let collectionDescriptionFrame;

  function scheduleCollectionDescriptionUpdate(scope = document) {
    window.cancelAnimationFrame(collectionDescriptionFrame);
    collectionDescriptionFrame = window.requestAnimationFrame(() => updateCollectionDescriptions(scope));
  }

  function handleProductCardClick(event) {
    if (event.defaultPrevented || event.button !== 0 || window.getSelection()?.toString()) return;

    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const card = target?.closest('[data-product-block]');
    if (!card) return;

    const interactive = target.closest(
      'a, button, input, select, textarea, label, form, [role="button"], '
      + '.product-grid-item__quick-buy, .product-grid-item__options-container, .upng-fav-icon'
    );
    if (interactive) return;

    const link = card.querySelector('.product-grid-item__link[href]');
    if (!link) return;

    if (event.ctrlKey || event.metaKey) {
      window.open(link.href, '_blank', 'noopener');
    } else {
      window.location.assign(link.href);
    }
  }

  // Initialize on DOM content loaded
  document.addEventListener('DOMContentLoaded', () => {
    initReadMoreButtons();
    scheduleCollectionDescriptionUpdate();
  });

  // Re-initialize when Shopify section is reloaded
  document.addEventListener('shopify:section:load', (event) => {
    initReadMoreButtons(event.target);
    scheduleCollectionDescriptionUpdate(event.target);
  });

  window.addEventListener('resize', () => scheduleCollectionDescriptionUpdate());
  document.addEventListener('click', handleProductCardClick);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



function toggleTextTruncation(event, selector) {
  event.preventDefault();
  const text = document.querySelector(selector);
  if (text.classList.contains('truncate-content')) {
    text.classList.remove('truncate-content');
  } else {
    text.classList.add('truncate-content');
  }
  const button = event.target;
  button.textContent = text.classList.contains('truncate-content') ? button.getAttribute('data-view-more') : button.getAttribute('data-view-less');
}
